import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { useApi } from '@fortem-monorepo/react-spa'
import { Marketdata } from '@fortem-monorepo/web-sdk'

export const useRunMarketdataJobMutation = () => {
  const api = useApi()

  return useMutation({
    mutationFn: (params: Marketdata.RunMarketdataJobParams) => {
      return api.marketdata.runJobs(params)
    },
    onSuccess(_data, variables) {
      const jobLabel = variables.chosen_jobs?.length ? variables.chosen_jobs.join(', ') : 'Jobs'
      toast.success(`${jobLabel} queued successfully`)
    },
  })
}
